import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/deals/[id]/messages/Page";

export const PATH = (id: number): string => `/vendors/deals/${id}/messages`;

const DealsDetail: NextPage = () => (
	<>
		<NskHead title="管理会社とチャット" />
		<VendorLayoutV2>
			<Component />
		</VendorLayoutV2>
	</>
);

export default DealsDetail;
